import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SectionHeader from '../components/sections/partials/SectionHeader';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import '../assets/scss/style.scss';

const About = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {
    const childRef = useRef();
    let location = useLocation();

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
        title: 'Why Luckynote exists'
    };

    return (
        <CustomStyle>
            <Header navPosition="right" className="reveal-from-bottom" />
            <main className="site-content">
                <section {...props} className={outerClasses}>
                    <div className="container-sm">
                        <div className={innerClasses} style={{ textAlign: 'left' }}>
                            <SectionHeader data={sectionHeader} className="center-content" tag="h1" />

                            <div style={{ textAlign: 'center', margin: '32px 0 40px' }}>
                                <div style={{
                                    width: '140px',
                                    height: '140px',
                                    borderRadius: '50%',
                                    margin: '0 auto 20px',
                                    overflow: 'hidden'
                                }}>
                                    <img
                                        src={require('../assets/images/founder-uros.jpg')}
                                        alt="Uros, Founder of Luckynote"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </div>
                                <h3 style={{ margin: '0 0 4px', fontSize: '20px', fontWeight: '600' }}>Uros</h3>
                                <p style={{ margin: 0, fontSize: '14px', color: '#999' }}>Founder & Developer</p>
                                <p style={{ margin: '12px 0 0', fontSize: '14px' }}>
                                    <Link to="/about/uros" style={{ color: '#2b88d9', fontWeight: 600 }}>
                                        More about Uros
                                    </Link>
                                </p>
                            </div>

                            <p className="m-0 text-sm">
                                I had things saved everywhere. Different apps, different folders, different devices. I spent more time trying to remember <em>where</em> something was than actually using it.
                            </p>
                            <p className="m-0 text-sm mt-16">
                                For a while, texting myself worked. One thread, everything in one place. But it doesn't scale. I was only ever saving the simplest things, when there was so much more I wanted to keep and actually use later.
                            </p>
                            <p className="m-0 text-sm mt-16">
                                So I took everything I knew about product design and the note-taking pain I'd lived with for years, and built the tool I actually wanted: something fast, straightforward, and reliable, where I can find anything I've ever saved without having to feel lucky about it.
                            </p>
                            <p className="m-0 text-sm mt-16">
                                That's why it's called Luckynote. Not because finding things is a gamble, but because with the right tool, you get to feel lucky every single day.
                            </p>

                            <h4 className="mt-32 mb-8">What we're building toward</h4>
                            <p className="m-0 text-sm">
                                Luckynote is for people who already message themselves notes, links, and reminders, and are tired of that thread turning into a mess. Our job is simple: make saving something take no thought at all, and make finding it again feel instant, no matter how much you've saved.
                            </p>

                            <p className="m-0 text-sm mt-32">
                                Have feedback, a question, or just want to say hi? Reach out any time at <b>support@luckynote.io</b>, <a href="https://x.com/lucky_uros" target="_blank" rel="noopener noreferrer" style={{ color: '#2b88d9' }}>follow along on X</a>, or <a href="https://www.instagram.com/lucky_uros/" target="_blank" rel="noopener noreferrer" style={{ color: '#2b88d9' }}>Instagram</a>.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </CustomStyle>
    );
};

const CustomStyle = styled.div`
    body {
        font-size: 1rem;
    }
`;

export default About;
